import { ReviewHistoryResponse } from '@/models/review-history.model';

export interface ReviewHistoryState {
  reviewHistory: ReviewHistoryResponse | null;
  loading: boolean;
  error: any;
}

export const initialReviewHistoryState: ReviewHistoryState = {
  reviewHistory: null,
  loading: false,
  error: null,
};